import React, { createContext, memo, useState } from 'react'
import { ApiCore, RegisterData } from '@monorepo/api'

interface Props {
  bonusId?: number
  ads?: {
    versions: { v1?: boolean; v2?: boolean }
    mania: 'mania1' | 'mania2'
  }
  reCaptchaKey?: string
}

export const ContextApp = createContext<
  {
    sid: string | null
    setSid?: (value: null | string) => void
    isCdaPending: boolean | null
    setIsCdaPending?: (value: boolean) => void
    dataRegister: RegisterData | null
    setDataRegister?: (value: RegisterData | null) => void
    isCdaCheck: boolean
    setIsCdaCheck?: (value: boolean) => void
    isCdaBalancerInfoLoading: boolean
    setIsCdaBalancerInfoLoading?: (value: boolean) => void
    cdaBalancerInfo: ApiCore.CDALandingsResponse | null
    setCdaBalancerInfo?: (value: ApiCore.CDALandingsResponse | null) => void
  } & Props
>({
  sid: null,
  dataRegister: null,
  isCdaPending: null,
  isCdaCheck: false,
  isCdaBalancerInfoLoading: false,
  cdaBalancerInfo: null,
})

export const ContextProvider: React.FC<React.PropsWithChildren & Props> = memo(
  ({ children, bonusId, ads, reCaptchaKey }) => {
    const [sid, setSid] = useState<string | null>(null)
    const [isCdaPending, setIsCdaPending] = useState<boolean>(false)
    const [isCdaCheck, setIsCdaCheck] = useState<boolean>(false)
    const [dataRegister, setDataRegister] = useState<RegisterData | null>(null)
    const [isCdaBalancerInfoLoading, setIsCdaBalancerInfoLoading] = useState<boolean>(false)
    const [cdaBalancerInfo, setCdaBalancerInfo] = useState<ApiCore.CDALandingsResponse | null>(null)

    return (
      <ContextApp.Provider
        value={{
          sid,
          setSid,
          dataRegister,
          setDataRegister,
          isCdaPending,
          setIsCdaPending,
          isCdaCheck,
          setIsCdaCheck,
          isCdaBalancerInfoLoading,
          setIsCdaBalancerInfoLoading,
          cdaBalancerInfo,
          setCdaBalancerInfo,
          bonusId,
          ads,
          reCaptchaKey,
        }}
      >
        {children}
      </ContextApp.Provider>
    )
  },
)
